import { combineReducers } from 'redux';

import chatReducer from './chats/ChatReducer';
import CustomizerReducer from './customizer/CustomizerReducer';
import emailReducer from './email/EmailReducer';
import flowReducer from './flows/flowSlice';
import notesReducer from './notes/NotesReducer';

const RootReducers = combineReducers({
  CustomizerReducer,
  chatReducer,
  notesReducer,
  emailReducer,
  flowReducer,
});

export default RootReducers;
